import {ajaxRest} from './ajaxBase'

const CONTROLLER_PREFIX = 'user'

function getUserStatistics () {
  let p = new Promise((resolve, reject) => {
    let params
    params = {
      url: `/${CONTROLLER_PREFIX}/statistics`,
      method: 'GET',
      timeout: {client: 10 * 1000}
    }
    ajaxRest(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

function getUser () {
  let p = new Promise((resolve, reject) => {
    let params
    params = {
      url: `/${CONTROLLER_PREFIX}`,
      method: 'GET',
      timeout: {client: 10 * 1000}
    }
    ajaxRest(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

function updateUser (param) {
  let p = new Promise((resolve, reject) => {
    let params
    params = {
      url: `/${CONTROLLER_PREFIX}`,
      data: param,
      method: 'PUT',
      timeout: {client: 10 * 1000}
    }
    ajaxRest(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

function deleteUser (param) {
  let p = new Promise((resolve, reject) => {
    let params
    params = {
      url: `/${CONTROLLER_PREFIX}`,
      method: 'DELETE',
      data: param,
      timeout: {client: 10 * 1000}
    }
    ajaxRest(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

function addUser (param) {
  let p = new Promise((resolve, reject) => {
    let params
    params = {
      url: `/${CONTROLLER_PREFIX}`,
      method: 'POST',
      data: param,
      timeout: {client: 10 * 1000}
    }
    ajaxRest(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

function getUserOrgBinding (param) {
  let p = new Promise((resolve, reject) => {
    let params
    params = {
      url: `/${CONTROLLER_PREFIX}/binding?${param}`,
      method: 'GET',
      timeout: {client: 10 * 1000}
    }
    ajaxRest(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

function updateUserOrgBinding (param) {
  let p = new Promise((resolve, reject) => {
    let params
    params = {
      url: `/${CONTROLLER_PREFIX}/binding`,
      method: 'PUT',
      data: param,
      timeout: {client: 10 * 1000}
    }
    ajaxRest(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

function setUserOrgBinding (param) {
  let p = new Promise((resolve, reject) => {
    let params
    params = {
      url: `/${CONTROLLER_PREFIX}/binding/set`,
      method: 'PUT',
      data: param,
      timeout: {client: 10 * 1000}
    }
    ajaxRest(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

function deleteUserOrgBinding (param) {
  let p = new Promise((resolve, reject) => {
    let params
    params = {
      url: `/${CONTROLLER_PREFIX}/binding`,
      method: 'DELETE',
      data: param,
      timeout: {client: 10 * 1000}
    }
    ajaxRest(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

function changePassword (param) {
  let p = new Promise((resolve, reject) => {
    let params
    params = {
      url: `/${CONTROLLER_PREFIX}/password`,
      data: param,
      method: 'PUT',
      timeout: {client: 10 * 1000}
    }
    ajaxRest(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

function checkUserTokenAndAdd () {
  let p = new Promise((resolve, reject) => {
    let params = {
      url: `/${CONTROLLER_PREFIX}/adduseranyway`,
      method: 'GET',
      timeout: {client: 10 * 1000}
    }

    ajaxRest(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

function changeUserSettingRole (param) {
  let p = new Promise((resolve, reject) => {
    let params
    params = {
      url: `/${CONTROLLER_PREFIX}/info`,
      data: param,
      method: 'PUT',
      timeout: {client: 10 * 1000}
    }
    ajaxRest(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

function changeUserSettingPWD (param) {
  let p = new Promise((resolve, reject) => {
    let params
    params = {
      url: `/${CONTROLLER_PREFIX}/info`,
      data: param,
      method: 'PUT',
      timeout: {client: 10 * 1000}
    }
    ajaxRest(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

function changeUserTheme (param) {
  let p = new Promise((resolve, reject) => {
    let params
    params = {
      url: `/${CONTROLLER_PREFIX}/changeTheme`,
      method: 'POST',
      data: param,
      timeout: {client: 10 * 1000}
    }
    ajaxRest(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

export default {
  getUserStatistics,
  getUser,
  updateUser,
  deleteUser,
  updateUserOrgBinding,
  setUserOrgBinding,
  addUser,
  getUserOrgBinding,
  deleteUserOrgBinding,
  changePassword,
  checkUserTokenAndAdd,
  changeUserSettingRole,
  changeUserSettingPWD,
  changeUserTheme
}



// WEBPACK FOOTER //
// ./src/api/userManageAPI.js